module.exports = __webpack_public_path__ + "assets/4cd3d5a59d89adac363c3838931ca97c.mp3";